// import CryptoJS from 'crypto-js';



// // Function to encrypt the payload

// const generateRandomIV = () => {
//     // Generate a random 16-byte (128-bit) IV
//     const iv = CryptoJS.lib.WordArray.random(16);
  
//     // Convert the IV to a hexadecimal string
//     const ivHex = iv.toString(CryptoJS.enc.Hex);
  
//     return ivHex;
//   };

// export const  encryptPayload=(payload)=> {
//     const secretKey = '243f1ab8573db6907aa8cba13e98cf4fa9a611d10e353ee7dd78b9da9b33c0d5';
//     const iv = generateRandomIV();
//     const ciphertext = CryptoJS.AES.encrypt(
//         JSON.stringify(payload),
//         CryptoJS.enc.Hex.parse(secretKey),
//         {
//             iv: CryptoJS.enc.Hex.parse(iv),
//             mode: CryptoJS.mode.CBC,
//             padding: CryptoJS.pad.Pkcs7
//         }
//     )
//     return {'payload':ciphertext.ciphertext.toString(CryptoJS.enc.Hex),'transactionId':iv};
// }

// // Function to decrypt the response
// export const decryptResponse=(ciphertext,iv) =>{
//     const secretKey = '243f1ab8573db6907aa8cba13e98cf4fa9a611d10e353ee7dd78b9da9b33c0d5';
   
//     const bytes = CryptoJS.AES.decrypt(
//         {ciphertext:CryptoJS.enc.Hex.parse(ciphertext)},
//         CryptoJS.enc.Hex.parse(secretKey),
//         {
//             iv: CryptoJS.enc.Hex.parse(iv),
//             mode: CryptoJS.mode.CBC,
//             padding: CryptoJS.pad.Pkcs7
//         }
//     );
//     const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
//     return decryptedData;
// }



import CryptoJS from "crypto-js";


  const SECRET_KEY = '0123456789abcdef0123456789abcdef';


const generateRandomIV = () => {
  return CryptoJS.lib.WordArray.random(16)
    .toString(CryptoJS.enc.Hex);
};


/*
|--------------------------------------------------------------------------
| Encrypt Request
|--------------------------------------------------------------------------
*/

export const encryptPayload = (payload) => {

  const iv = generateRandomIV();

  const encrypted = CryptoJS.AES.encrypt(
    JSON.stringify(payload),
    CryptoJS.enc.Hex.parse(SECRET_KEY),
    {
      iv: CryptoJS.enc.Hex.parse(iv),
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    }
  );

  return {
    payload: encrypted.ciphertext.toString(
      CryptoJS.enc.Hex
    ),
    transactionId: iv
  };
};


/*
|--------------------------------------------------------------------------
| Decrypt Response
|--------------------------------------------------------------------------
*/

export const decryptResponse = (
  ciphertext,
  iv
) => {

  const decrypted = CryptoJS.AES.decrypt(
    {
      ciphertext:
        CryptoJS.enc.Hex.parse(ciphertext)
    },
    CryptoJS.enc.Hex.parse(SECRET_KEY),
    {
      iv: CryptoJS.enc.Hex.parse(iv),
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    }
  );

  const decryptedText =
    decrypted.toString(CryptoJS.enc.Utf8);

  if (!decryptedText) {
    throw new Error(
      "Unable to decrypt server response."
    );
  }

  return JSON.parse(decryptedText);
};